module.exports = __webpack_public_path__ + "img/icon.720185e6.png";